"use client";

import { createContext, useContext } from "react";

const ComputeUiContext = createContext(false);

export function ComputeUiProvider({ enabled, children }: { enabled: boolean; children: React.ReactNode }) {
  return <ComputeUiContext.Provider value={enabled}>{children}</ComputeUiContext.Provider>;
}

export function useComputeUiEnabled() { return useContext(ComputeUiContext); }
